module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlackItalic.dfd759e.woff2";